<template>
<div ref="nest" v-if="!this.loading">
  <p v-if="isOverviewPage" class="text-xl font-semibold pl-2.5 mb-2.5 mt-6 xl:pl-0">
    <span v-if="title">{{ title }}</span>
    <span v-else>Faza grupowa - {{ leagueName }}</span>
  </p>
  <football-stats-filter class="bg-zt-light/35 pt-2.5 border-t border-x border-zt-light rounded-t-zt"
                         :is-league-results="true" :options="filteringOptions" :showHomeAway="false"
                         @filtering-changed="(value) => changeFilters(value)"></football-stats-filter>
  <StandingsTable :group-title="window.size.mobile ? 'Drużyna' : ''"
                  :rounded-top="false"
                  :teams="tableToShow" :filters="['all']" :details="groupDetails"
                  :show-promotion="true"
                  :highlighted-team="activeTeam"
                  :redirect-to-team="leagueId !== 480"
                  :league-id="leagueId"
                  :no-corners="true"
                  :show-expander="false"
                  :sorting="false" />
</div>
</template>

<script>

import utils_mixin from "../mixins/utils_mixin";
import FootballStatsFilter from "../components/FootballStatsFilter.vue";
import StandingsTable from "../components/football_tables/StandingsTable.vue";
import football_mixin from "../mixins/football_mixin";

export default {
  name: 'FootballLeagueNestedGroups',
  components: {StandingsTable, FootballStatsFilter},
  inject: ['WP'],
  mixins: [utils_mixin, football_mixin],
  props: {
    title: {
      type: String,
    }
  },
  data() {
    return {
      filteringOptions: [],
      selectedFilters: [],
      groups: [],
      loading: true,
      leagueDetails: [],
	    timesFilterChanged: 0
    }
  },
  computed: {
    leagueId() {
      return +this.$attrs.leagueId;
    },
	  activeTeam() {
		  if (!this.$attrs.teamId) {
			  return -1;
		  }
		  return +this.$attrs.teamId;
	  },
    leagueName() {
      return this.$attrs.leagueName;
    },
    isOverviewPage() {
      if (!this.$attrs.isOverview) {
        return false;
      }
      return this.$attrs.isOverview === 'true';
    },
    tableToShow() {
      if (Object.keys(this.groups).length > 0 && this.selectedFilters.length > 0) {
        let allGroups = Object.entries(this.groups);
        let index = allGroups.findIndex(el => {
          return el[0] === this.selectedFilters[0] + ' - ' + this.selectedFilters[1];
        })
        if (index !== -1) {
          return allGroups[index][1];
        }
        return [];
      }
      return [];
    },
    groupDetails() {
      let details = {};
      this.tableToShow.forEach(team => {
        if ( team.standings.position_details.length > 0 ) {
          if (details.hasOwnProperty(team.standings.position_details)) {
            details[team.standings.position_details].n += 1;
          } else {
            details[team.standings.position_details] = {
              n: 1,
              polish_details: team.standings.polish_details
            };
          }
        }
      });
      return details;
    }
  },
  mounted() {
    axios
      .post(this.WP.ajaxUrl, {
        endpoint: 'api_get_league_groups',
        league_id: this.leagueId
      })
      .then(response => {
        this.groups = response.data.data.groups;
        this.leagueDetails = response.data.data.league;
        if (this.groups === undefined) {
          this.groups = [];
          this.leagueDetails = response.data.data.league;
          this.removePlaceholder(this.$attrs.section);
        }
        if (this.leagueId === 5) {
          const teams = [
            this.groups['League C - Group 1'][3],
            this.groups['League C - Group 2'][3],
            this.groups['League C - Group 3'][3],
            this.groups['League C - Group 4'][3]
          ];
          this.groups['League C - 4th place'] = teams.sort((a, b) => {
            const pointsA = (+a.standings.wins * 3) + (+a.standings.draws);
            const pointsB = (+b.standings.wins * 3) + (+b.standings.draws);
            if (pointsA === pointsB) {
              const goalsA = +a.standings.goals_for - +a.standings.goals_against;
              const goalsB = +b.standings.goals_for - +b.standings.goals_against;
              return goalsB - goalsA;
            }
            return pointsB - pointsA;
          });
        }
        Object.keys(this.groups).forEach(group => {
          let splitedGroupName = group.split(' - ');
          let mainGroupIndex = this.filteringOptions.findIndex(el => {
            return el.value === splitedGroupName[0];
          });
          if (this.filteringOptions.length === 0 || mainGroupIndex === -1) {
            this.filteringOptions.push({
              name: splitedGroupName[0].replace('League', 'Liga'),
              value: splitedGroupName[0],
              options: [
                {
                  name: splitedGroupName[1].replace('Group', 'Grupa').replace('4th place', 'Z 4. miejsc'),
                  value: splitedGroupName[1],
                  options: [],
                }
              ]
            })
            if (this.selectedFilters.length === 0) {
              this.selectedFilters = splitedGroupName;
            }
          } else if (mainGroupIndex !== -1) {
            let subgroupIndex = this.filteringOptions[mainGroupIndex].options.findIndex(el => {
              return el.value === splitedGroupName[1];
            })
            if (subgroupIndex === -1) {
              this.filteringOptions[mainGroupIndex].options.push({
                name: splitedGroupName[1].replace('Group', 'Grupa').replace('4th place', 'Z 4. miejsc'),
                value: splitedGroupName[1],
                options: [],
              })
            }
          }
        })
        this.loading = false;
        this.removePlaceholder(this.$attrs.section);
        let additionalTableIndex = -1;
        let mainTableIndex = 0;
        this.filteringOptions.forEach(option => {
          additionalTableIndex = option.options.findIndex(el => el.value === '4th place');
          if (additionalTableIndex !== -1) {
            this.filteringOptions[mainTableIndex].options.push(this.filteringOptions[mainTableIndex].options[additionalTableIndex]);
            this.filteringOptions[mainTableIndex].options.splice(additionalTableIndex, 1);
          }
          mainTableIndex++;
        });
	      if (this.activeTeam !== -1) { //NASTY AF, do przemyślenia
		      let allGroups = Object.entries(this.groups);
		      let foundKey = '';
		      allGroups.forEach(entry => {
			      entry[1].forEach(team => {
				      if (+team.team_id === this.activeTeam) {
					      foundKey = entry[0];
								let foundKeyCopy = foundKey;
					      foundKey = foundKey.split(' - ');
					      if (!(foundKey[0] === this.selectedFilters[0] && foundKey[1] === this.selectedFilters[1])) {
						      foundKeyCopy = foundKeyCopy.replaceAll('League', 'LIGA');
						      foundKeyCopy = foundKeyCopy.replaceAll('Group', 'GRUPA');
									foundKeyCopy = foundKeyCopy.split(' - ');

						      setTimeout(() => {
										if (foundKeyCopy[0] !== this.selectedFilters[0]) {
											const buttons = this.$refs.nest.querySelectorAll('.filtering-button-main');
											buttons.forEach(item => {
												if (item.innerText === foundKeyCopy[0]) {
													item.click();
												}
											})
										}
							      setTimeout(() => {
								      if (foundKeyCopy[1] !== this.selectedFilters[1]) {
									      const buttons = this.$refs.nest.querySelectorAll('.filtering-button-inactive');
									      buttons.forEach(item => {
										      if (item.innerText === foundKeyCopy[1]) {
											      item.click();
										      }
									      })
								      }
							      }, 100);
						      }, 100);
					      }
				      }
			      })
		      })
	      }
      });
  },
  methods: {
    changeFilters(value) {
      this.selectedFilters = value;
    },
  }
}

</script>

<style>

</style>